import { Injectable, inject } from '@angular/core';
import type {
  MarkdownEditorKiraPort,
  MarkdownEditorKiraResult,
  MarkdownEditorKiraRole,
} from '@catch/markdown-editor';
import type { Observable } from 'rxjs';
import { CompanionAdapter } from './companion.adapter';

@Injectable()
export class MarkdownEditorKiraAdapter implements MarkdownEditorKiraPort {
  private readonly companionAdapter = inject(CompanionAdapter);

  generateText(
    prompt: string,
    role: MarkdownEditorKiraRole
  ): Observable<MarkdownEditorKiraResult> {
    return this.companionAdapter.generateEditorText(prompt, role);
  }

  optimizeText(
    text: string,
    role: MarkdownEditorKiraRole,
    prompt?: string
  ): Observable<MarkdownEditorKiraResult> {
    return this.companionAdapter.optimizeEditorText(text, role, prompt);
  }
}
